<template>
		<router-view />
</template>

<script>

export default {
  name: 'index',
  
}
</script>
<style  lang="scss" scoped="scoped">

</style>
